export default __webpack_public_path__ + "static/media/@_isabelaferrer_.428fd365.jpg";